var _defs, _path, _path2, _circle, _path3, _path4, _path5, _circle2, _circle3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBuildPackage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "build-package_svg__Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 150 150"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".build-package_svg__cls-1{fill:#f8f8f8}.build-package_svg__cls-1,.build-package_svg__cls-2,.build-package_svg__cls-4{stroke:#0e5b7c;stroke-linecap:round}.build-package_svg__cls-1,.build-package_svg__cls-2{stroke-miterlimit:10}.build-package_svg__cls-2{fill:none}.build-package_svg__cls-4{stroke-linejoin:round;fill:#6e9db0}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "build-package_svg__cls-1",
    d: "M118.72 65.11L75.07 39.75 31.14 65.11l.14 50.48 43.65 25.36 43.93-25.36-.14-50.48z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "build-package_svg__cls-2",
    d: "M75 45.56v38.96"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 74.46,
    cy: 83.73,
    r: 24.58,
    strokeLinejoin: "round",
    fill: "#fbc282",
    stroke: "#0e5b7c",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "build-package_svg__cls-1",
    d: "M31.14 65.11l.14 50.48 43.65 25.36 43.93-25.36-.14-50.44-43.86 25.32-43.65-25.36M118.78 65.11l21.56-12.52-43.75-25.26-21.41 12.44 43.6 25.34zM74.96 39.85L53.41 27.33 9.66 52.59l21.55 12.52 43.75-25.26z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "build-package_svg__cls-1",
    d: "M74.86 90.47L31.39 65.21 9.66 77.84l43.75 25.26L75 90.55l21.59 12.55 43.75-25.26-21.73-12.62-43.75 25.25z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "build-package_svg__cls-2",
    d: "M75 96.04v38.73"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "build-package_svg__cls-4",
    cx: 50.68,
    cy: 46.41,
    r: 8.86
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "build-package_svg__cls-4",
    cx: 97.38,
    cy: 26.89,
    r: 12.33
  })));
}
export default SvgBuildPackage;